module.exports = __webpack_public_path__ + "static/frontUserNew/img/professional-02.7bc4492f.png";